import axios from 'axios'

axios.defaults.headers.post.Accept = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'

const apiUrl = process.env.NODE_ENV === 'development'
  'https://vybroo.net/api'
  

const api = (data) => {
  return axios.post(apiUrl, data)
}

export default api
